import { useMemo } from 'react';
import WithAttachment from './SubjectWithAttachment';
import NextSvg from 'imagesUwKluis/svg/open.svg';
import Table from '../../shared/Table';
import {formatISODate} from "../../../utils/dateHelpers";
import i18n from "../../../i18n";

const getColumns = () => [
  {
    Header: i18n.t('Onderwerp'),
    accessor: 'withAttachment',
    width: 200 * 0.5,
  },
  {
    Header: i18n.t('Datum'),
    accessor: 'created_at',
    width: 200 * 0.2,
    Cell: ({ value }) => formatISODate(value),
  },
  {
    accessor: 'arrow',
    width: '1.5rem',
  },
];

const MessagesTable = ({ messages, handleRowClick }) => {
  const columns = getColumns();

  const rows = useMemo(
    () =>
      messages?.map((message) => ({
        ...message,
        withAttachment: (
          <WithAttachment
            subject={message.subject}
            hasAttachment={message.attachments?.length > 0}
          />
        ),
        isBold: !message.read_at,
        arrow: (
          <NextSvg
            width="1.5rem"
            height="1.5rem"
            css={(theme) => ({
              margin: 'calc((1rem - 1.5rem) / 2) 0',
              fill: theme?.colors?.primary || 'black',
            })}
          />
        ),
      })),
    [messages]
  );

  return (
    <Table columns={columns} data={rows} handleRowClick={handleRowClick} />
  );
};

export default MessagesTable;
